import { BuildHtml } from "~/components/BuildHtml";
import { Body } from "~/ui-library/components/Body";
import { Headline, HeadlineProps } from "~/ui-library/components/Headline";
import { isPopulatedString } from "~/lib/shared/isPopulatedString";

type HeaderProps = {
  headline?: string;
  subtitle?: string;
  title?: string;
  headlineId?: string;
  headlineAs?: HeadlineProps["as"];
  headlineLevel: HeadlineProps["level"];
  hideHeadline?: boolean;
};

export const EvervizChartHeader = ({
  headline,
  subtitle,
  title,
  headlineId,
  headlineAs,
  headlineLevel,
  hideHeadline,
}: HeaderProps) => (
  <div id="headline-container" className="mb-2 flex w-full flex-col">
    {isPopulatedString(headline) && !hideHeadline && (
      <>
        <Headline
          as={headlineAs}
          id={headlineId}
          level={headlineLevel}
          className="scroll-mt-xxl pb-xs"
        >
          {headline}
        </Headline>
      </>
    )}
    {isPopulatedString(subtitle) && (
      <>
        <Body className="text-body-regular">
          <BuildHtml allowStyles html={subtitle} />
        </Body>
      </>
    )}
    {isPopulatedString(title) && (
      <Body bold className="py-xs text-body-regular">
        <BuildHtml allowStyles html={title} />
      </Body>
    )}
  </div>
);
